import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-82187062"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24 -md:pt-16 p-5" }
const _hoisted_2 = { class: "px-6 py-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-left pb-5" }, "Downloads", -1))
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_6 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_7 = { class: "shadow overflow-hidden border-b border-gray-200 sm:rounded-lg" }
const _hoisted_8 = { class: "block w-auto md:flex m-3 gap-5" }
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<table id=\"example\" class=\"stripe hover\" style=\"width:100%;padding-top:1em;padding-bottom:1em;\" data-v-82187062><caption data-v-82187062></caption><thead data-v-82187062><tr data-v-82187062><th scope=\"col\" data-priority=\"1\" data-v-82187062>Data</th><th scope=\"col\" data-priority=\"2\" data-v-82187062>Versão</th><th scope=\"col\" data-priority=\"2\" data-v-82187062>Descrição</th><th scope=\"col\" data-priority=\"3\" data-v-82187062> </th></tr></thead><tbody data-v-82187062><tr data-v-82187062><td data-v-82187062>21/12/2021</td><td data-v-82187062>3.2.12</td><td data-v-82187062>Manager SaaS 4.X MANAGERNEVERSTOP 2.1.37.72162</td><td class=\"flex gap-5\" data-v-82187062><a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://tecnospeed-instaladores.s3-sa-east-1.amazonaws.com/PrintManager_4.1.14.28.exe?AWSAccessKeyId=AKIAJNPUVPZSVFA6VBRA&amp;Expires=1639538146&amp;Signature=gfkxJbycBud9ATuO8FhAKop9k3s%3D\" class=\"ml-auto border-green-500 border rounded-lg text-green-500 p-2 cursor-pointer hover:bg-green-500 hover:text-white transition\" data-v-82187062> Baixar </a><a rel=\"noopener noreferrer\" target=\"_blank\" href=\"https://atendimento.tecnospeed.com.br/hc/pt-br/articles/360007316574\" class=\"border-blue-500 border rounded-lg text-blue-500 p-2 cursor-pointer hover:bg-blue-500 hover:text-white transition\" data-v-82187062> Novidades </a></td></tr></tbody></table>", 1)
const _hoisted_10 = { class: "py-8 pt-3" }
const _hoisted_11 = { class: "block md:flex gap-5" }
const _hoisted_12 = { class: "block" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Descrição ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = {
  key: 0,
  class: "text-red-500 text-xs"
}
const _hoisted_16 = { class: "gap-5 flex" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title text-left py-5" }, "Experimente nossos produtos", -1))
const _hoisted_18 = { class: "flex w-full gap-5" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-8 pt-3 gap-5 text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block mb-10" }, " Do desktop ao celular, sem programar! "),
  /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-center text-center" }, [
    /*#__PURE__*/_createElementVNode("a", {
      rel: "noopener noreferrer",
      target: "_blank",
      href: "https://plugmobile.com.br/",
      class: "w-full border-blue-500 border rounded-lg text-blue-500 p-2 cursor-pointer hover:bg-blue-500 hover:text-white transition"
    }, " Conheça ")
  ])
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-8 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block md:flex gap-5 mb-5 text-center" }, " Ofereça certificado digital aos clientes do seu software! "),
  /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-center text-center" }, [
    /*#__PURE__*/_createElementVNode("a", {
      rel: "noopener noreferrer",
      target: "_blank",
      href: "https://tecnospeed.com.br/certificado-digital/",
      class: "w-full border-blue-500 border rounded-lg text-blue-500 p-2 cursor-pointer hover:bg-blue-500 hover:text-white transition"
    }, " Conheça ")
  ])
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "py-8 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "block md:flex gap-5 mb-5 text-center" }, " Emita notas fiscais no seu software sem esforço! "),
  /*#__PURE__*/_createElementVNode("div", { class: "flex w-full justify-center text-center" }, [
    /*#__PURE__*/_createElementVNode("a", {
      rel: "noopener noreferrer",
      target: "_blank",
      href: "https://github.com/tecnospeed/Componente-NFe",
      class: "w-full border-green-500 border rounded-lg text-green-500 p-2 cursor-pointer hover:bg-green-500 hover:text-white transition"
    }, " Baixar Versão de Testes ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.registering)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Select, {
                      selected: "Produto",
                      label: "",
                      placeholder: "Selecione um produto",
                      options: () => _ctx.selectValues,
                      display: "descricao",
                      itemId: "value",
                      labelClass: "p-0 text-left",
                      event: "update:editValue",
                      class: "w-fill",
                      "onUpdate:editValue": _ctx.changeTypeFilter
                    }, null, 8, ["options", "onUpdate:editValue"])
                  ]),
                  _hoisted_9
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.registering)
        ? (_openBlock(), _createBlock(_component_Card, {
            key: 1,
            class: "pt-8 px-6 m-5 mx-auto",
            width: "max-w-min",
            title: "Cadastrar nova mensagem",
            orientation: "flex-col"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Select, {
                    selected: "Produto",
                    label: "Produto",
                    options: () => _ctx.selectValues,
                    display: "descricao",
                    itemId: "value",
                    labelClass: "p-0 text-left",
                    event: "update:editValue",
                    class: "w-6/6 md:w-3/6",
                    "onUpdate:editValue": _ctx.changeType,
                    incorrectMessage: _ctx.validations.package,
                    isIncorrect: _ctx.validations.package != ''
                  }, null, 8, ["options", "onUpdate:editValue", "incorrectMessage", "isIncorrect"]),
                  _createVNode(_component_Input, {
                    label: "Título",
                    class: "w-6/6 md:w-3/6",
                    incorrectMessage: _ctx.validations.titulo,
                    isIncorrect: _ctx.validations.titulo != '',
                    labelClass: "p-0 text-left",
                    modelValue: _ctx.mensagem.titulo,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mensagem.titulo) = $event))
                  }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _hoisted_14,
                  _withDirectives(_createElementVNode("textarea", {
                    class: "border outline-none border-gray-300 rounded-lg w-full p-3 mb-3 custom-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.mensagem.descricao) = $event)),
                    rows: "5"
                  }, null, 512), [
                    [_vModelText, _ctx.mensagem.descricao]
                  ])
                ]),
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.mensagem.dates,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mensagem.dates) = $event)),
                  "is-range": "",
                  columns: _ctx.width() > 768 ? 2 : 1,
                  class: _normalizeClass(["my-1", _ctx.validations.dates != '' ? 'border-red-500' : ''])
                }, null, 8, ["modelValue", "columns", "class"]),
                (_ctx.validations.dates != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Informe as datas de visibilidade da mensagem! "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Button, {
                    label: "Voltar",
                    onClick: _ctx.back,
                    class: "p-0 my-4 w-full divide-transparent",
                    width: "w-min"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_PrimaryButton, {
                    isLoading: _ctx.loading,
                    label: "Enviar",
                    onClick: _ctx.send,
                    class: "p-0 my-4 w-full divide-transparent text-white",
                    width: "w-full",
                    type: "submit"
                  }, null, 8, ["isLoading", "onClick"])
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_Card, {
          class: "pt-8 px-6 w-12/12 md:w-6/12 lg:w-4/12 justify-start",
          title: "PlugMobile",
          hover: true,
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            _hoisted_19
          ]),
          _: 1
        }),
        _createVNode(_component_Card, {
          class: "pt-8 px-6 w-12/12 md:w-6/12 lg:w-4/12 justify-start",
          title: "Certificados",
          hover: true,
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            _hoisted_20
          ]),
          _: 1
        }),
        _createVNode(_component_Card, {
          class: "pt-8 px-6 w-12/12 md:w-6/12 lg:w-4/12 justify-start",
          title: "Componente NFe",
          hover: true,
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_Toast, {
        label: _ctx.message,
        hidden: _ctx.hidden,
        onHide: _ctx.hide
      }, null, 8, ["label", "hidden", "onHide"])
    ])
  ]))
}